<default-dialog [title]="title" [buttons]="buttons" [dialogClass]="dialogClass" [closeButton]="closeButton" [loading]="loading" (onClose)="onCancel.emit()">
  <div *ngIf="error" class="alert alert-danger" >
    <i class="fa fa-exclamation-circle"></i>&nbsp;<span translate>{{error}}</span>
  </div>
  <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
</default-dialog>